<style lang="stylus" scoped>
.main
    .title
        font-size:16px;
        color:#040B21;
        margin:18px 0px;
    .bottom
        margin:45px 0px;
        text-align:center;
</style>
<template>
    <div class="main">
        <div class="title">付费知识</div>
        <div>
            <el-table style="min-width:1100px;width:100%;" :data="postlist" :header-cell-style="{background:'#FAFAFA',color:'rgba(0, 0, 0, 0.85)'}">
                <el-table-column prop="title" label="知识名称">
                    <template slot-scope="scoped">
                        <div style="cursor:pointer;color:#000000;" @click="$router.push({name: 'lawColumnInfo', params: {law_id: scoped.row.law_article_id}})" title="跳转知识详情">{{scoped.row.title}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="lawyer_real_names" label="创建者" width="200"></el-table-column>
                <el-table-column prop="pay_time" label="支付时间" width="200"></el-table-column>
                <el-table-column prop="pay_price" label="支付金额" width="200"></el-table-column>
            </el-table>
            <div class="bottom" v-if="total > perpage">
                <el-pagination
                   background
                   :current-page.sync="page"
                   :page-size="perpage"
                   @current-change="handleCurrentChange"
                   layout="prev, pager, next, total"
                   :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'payList',
    data() {
        return {
            postlist:[],
            page:1,
            total:0,
            perpage: 10,
        }
    },
    mounted(){
        this.getList();
    },
    methods: {
        getList(){
            let option = {
                page: this.page,
                per_page: this.perpage
            };
            this.$ajax('get', 'lawArticle/payList', option, res => {
                if(res.retcode === 0){
                    this.postlist = res.data;
                    this.total = res.total;
                };
            })
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/personalSetter/paylist.vue